import { AxiosHelper } from '@/modules/shared/infra/protocols/http';
import config from '@/Constants';

export const activateTask = async (taskId: string | number) => {
  const url = `${config.TASK_ACTIVATIONS_URL}/${taskId}/activate`;
  const response = await AxiosHelper.post({ url });

  if (response.statusCode < 200 || response.statusCode >= 300) {
    const body = response.body;
    let errorMessage = body?.message || body?.error || 'Falha ao ativar tarefa';
    let errorColor = 'red';

    if (Array.isArray(body?.error_messages)) {
      const firstError = body.error_messages[0];
      if (typeof firstError === 'object' && firstError !== null) {
        errorMessage = firstError.message || errorMessage;
        errorColor = firstError.color || errorColor;
      } else {
        errorMessage = body.error_messages.join(', ');
      }
    }

    throw new Error(JSON.stringify({ message: errorMessage, color: errorColor }));
  }

  return response.body;
};
